import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import "./App.css";
import { FormProvider } from "./context/FormContext";
import { ToastProvider } from "./context/ToastContext";
import { AuthProvider } from "./context/AuthContext";
import ToastContainer from "./components/Toast";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import HospitalDetails from "./components/HospitalDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import CombinedApplicationForm from "./components/CombinedApplicationForm";

const Header = () => {
  return (
    <div className="header">
      <div className="header-content-wrapper">
        <div className="header-text">
          <h1>Hospital Empanelment Application</h1>
          <p>Complete Application Form with Document Checklist</p>
        </div>
        <div className="header-actions">
          <Link to="/login" className="login-link-btn">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ToastProvider>
        <AuthProvider>
          <div className="app">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/hospital/:id"
                element={
                  <ProtectedRoute>
                    <HospitalDetails />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <FormProvider>
                    <Header />
                    <div className="container">
                      <CombinedApplicationForm />
                    </div>
                  </FormProvider>
                }
              />
              <Route
                path="/application"
                element={
                  <FormProvider>
                    <Header />
                    <div className="container">
                      <CombinedApplicationForm />
                    </div>
                  </FormProvider>
                }
              />
            </Routes>
            <ToastContainer />
          </div>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
